export const STEPS_STATUS_API = "/api/:customerSlug/product-request/api/steps-status";

export const getStepsStatusQueryKey = (customerDomain: string) => [
  STEPS_STATUS_API.replace(":customerSlug", customerDomain),
];
